import { useNavigate } from 'react-router-dom'

export default function TermsOfService() {
  const navigate = useNavigate()

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0B1E3D',
      color: '#F5EDD8',
      fontFamily: '"DM Sans", sans-serif',
      padding: '80px 24px 60px',
    }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>

        {/* Back */}
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'none', border: 'none', color: 'rgba(245,237,216,0.45)',
            cursor: 'pointer', fontSize: 14, fontFamily: '"DM Sans", sans-serif',
            marginBottom: 40, padding: 0, display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          ← Back to WaveSync
        </button>

        {/* Header */}
        <div style={{
          fontFamily: '"Playfair Display", serif',
          fontSize: 18, color: '#E8614A', fontWeight: 700, marginBottom: 16,
        }}>
          🌊 WaveSync
        </div>
        <h1 style={{
          fontFamily: '"Playfair Display", serif',
          fontSize: 'clamp(32px, 5vw, 48px)',
          fontWeight: 900, color: '#fff', margin: '0 0 12px',
        }}>
          Terms of Service
        </h1>
        <p style={{ fontSize: 14, color: 'rgba(245,237,216,0.35)', marginBottom: 56, borderBottom: '1px solid rgba(255,255,255,0.07)', paddingBottom: 32 }}>
          Last Updated: May 13, 2026 · WaveSync LLC
        </p>

        <p style={p}>
          By accessing or using WaveSync ("the Platform"), you agree to be bound by these Terms of Service ("Terms").
          If you do not agree, do not use the Platform. These Terms constitute a legally binding agreement between you
          ("Customer") and WaveSync LLC, a Pennsylvania limited liability company, located at 1690 Newtown Langhorne Rd,
          ATTN 4565, Newtown, PA 18940.
        </p>

        <Section>1. Description of Service</Section>
        <p style={p}>
          WaveSync provides a cloud-based software-as-a-service (SaaS) platform designed for surf schools and water
          sports operators. The Platform includes tools for scheduling, customer management, staff coordination, and
          related business management features.
        </p>

        <Section>2. Subscription Plans and Payment</Section>
        <Sub>2.1 Plans</Sub>
        <p style={p}>WaveSync offers the following subscription plans:</p>
        <ul style={ul}>
          <li><strong>Starter:</strong> $50.00 per month, or $599.00 annually (one-time payment) — up to 7 instructors</li>
          <li><strong>Standard:</strong> $108.00 per month, or $1,299.00 annually (one-time payment) — up to 14 instructors</li>
          <li><strong>Pro:</strong> $183.00 per month, or $2,199.00 annually (one-time payment) — unlimited instructors</li>
        </ul>
        <p style={p}>All plans include scheduling, instructor management, customer booking, Stripe payments, and live surf & weather. Higher tiers unlock AI instructor matching, payroll & CSV export, and analytics dashboard.</p>

        <Sub>2.2 Billing</Sub>
        <p style={p}>
          Payments are processed securely through Stripe. By subscribing, you authorize WaveSync to charge your
          payment method on a recurring basis. All fees are in U.S. dollars.
        </p>

        <Sub>2.3 Automatic Renewal</Sub>
        <p style={p}>
          Subscriptions renew automatically at the end of each billing period unless cancelled before the renewal date.
          You may cancel at any time through your account dashboard.
        </p>

        <Sub>2.4 Refunds</Sub>
        <p style={p}>
          Monthly subscriptions are non-refundable for partial months. Annual subscriptions may be eligible for a
          refund if requested within 14 days of the initial payment, at WaveSync's sole discretion. After 14 days,
          annual fees are non-refundable.
        </p>

        <Sub>2.5 Price Changes</Sub>
        <p style={p}>
          WaveSync reserves the right to modify pricing with 30 days' written notice. Continued use after the
          effective date constitutes acceptance of the new pricing.
        </p>

        <Section>3. Account Registration</Section>
        <p style={p}>
          You must create an account to use WaveSync. You agree to provide accurate, complete information and keep
          your credentials confidential. You are responsible for all activity under your account. Notify us immediately
          at <a href="mailto:drew@wavesync.cloud" style={link}>drew@wavesync.cloud</a> if you suspect
          unauthorized access.
        </p>

        <Section>4. Acceptable Use</Section>
        <p style={p}>You agree not to:</p>
        <ul style={ul}>
          <li>Use the Platform for any unlawful purpose</li>
          <li>Attempt to gain unauthorized access to any part of the Platform</li>
          <li>Interfere with or disrupt the integrity or performance of the Platform</li>
          <li>Reverse engineer, decompile, or disassemble any part of the Platform</li>
          <li>Resell or sublicense access to the Platform without prior written consent</li>
          <li>Upload or transmit any malicious code, viruses, or harmful content</li>
        </ul>

        <Section>5. Customer Data</Section>
        <Sub>5.1 Ownership</Sub>
        <p style={p}>
          You retain all ownership rights to the data you and your customers input into the Platform ("Customer Data").
          WaveSync does not claim ownership of Customer Data.
        </p>
        <Sub>5.2 License to WaveSync</Sub>
        <p style={p}>
          By using the Platform, you grant WaveSync a limited, non-exclusive license to store and process Customer
          Data solely to provide and improve the Platform as described in our Privacy Policy.
        </p>
        <Sub>5.3 Data Responsibility</Sub>
        <p style={p}>
          You are responsible for ensuring your collection and use of Customer Data complies with all applicable laws.
        </p>

        <Section>6. Intellectual Property</Section>
        <p style={p}>
          WaveSync and its licensors own all rights to the Platform, including software, designs, logos, and content
          (excluding Customer Data). These Terms do not grant you any rights to WaveSync's intellectual property
          except the limited right to use the Platform as described herein.
        </p>

        <Section>7. Third-Party Services</Section>
        <p style={p}>
          The Platform integrates with Stripe for payment processing. Your use of these services is subject to their
          respective terms and privacy policies. WaveSync is not responsible for third-party provider practices.
        </p>

        <Section>8. Disclaimer of Warranties</Section>
        <p style={p}>
          THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.
          WAVESYNC DOES NOT WARRANT THAT THE PLATFORM WILL BE ERROR-FREE OR UNINTERRUPTED.
        </p>

        <Section>9. Limitation of Liability</Section>
        <p style={p}>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, WAVESYNC LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
          SPECIAL, OR CONSEQUENTIAL DAMAGES. IN NO EVENT SHALL WAVESYNC'S TOTAL LIABILITY EXCEED THE AMOUNT PAID
          BY YOU IN THE THREE (3) MONTHS PRECEDING THE CLAIM.
        </p>

        <Section>10. Indemnification</Section>
        <p style={p}>
          You agree to indemnify and hold harmless WaveSync LLC from any claims, liabilities, damages, and expenses
          (including attorneys' fees) arising from your use of the Platform or violation of these Terms.
        </p>

        <Section>11. Termination</Section>
        <p style={p}>
          You may cancel at any time through your dashboard; access continues through the end of your billing period.
          WaveSync may suspend or terminate your account for violations of these Terms or non-payment. Upon termination,
          you may request a data export within 30 days, after which your data may be deleted.
        </p>

        <Section>12. Governing Law</Section>
        <p style={p}>
          These Terms are governed by the laws of the Commonwealth of Pennsylvania. Disputes shall be resolved in
          state or federal courts in Bucks County, Pennsylvania.
        </p>

        <Section>13. Changes to Terms</Section>
        <p style={p}>
          WaveSync may update these Terms at any time. We will notify you of material changes via email or Platform
          notice. Continued use after the effective date constitutes acceptance.
        </p>

        <Section>14. Contact</Section>
        <p style={p}>
          For questions about these Terms, contact us at{' '}
          <a href="mailto:drew@wavesync.cloud" style={link}>drew@wavesync.cloud</a>
          <br />
          WaveSync LLC · 1690 Newtown Langhorne Rd, ATTN 4565, Newtown, PA 18940
        </p>

        {/* Footer */}
        <div style={{
          marginTop: 64, paddingTop: 28,
          borderTop: '1px solid rgba(255,255,255,0.07)',
          display: 'flex', gap: 20, alignItems: 'center', flexWrap: 'wrap',
        }}>
          <button onClick={() => navigate('/privacy')} style={footerBtn}>Privacy Policy</button>
          <button onClick={() => navigate('/')} style={footerBtn}>Back to Home</button>
        </div>
      </div>
    </div>
  )
}

const p = {
  fontSize: 15, lineHeight: 1.75,
  color: 'rgba(245,237,216,0.65)',
  marginBottom: 16,
}
const ul = {
  fontSize: 15, lineHeight: 1.75,
  color: 'rgba(245,237,216,0.65)',
  paddingLeft: 24, marginBottom: 16,
}
const link = { color: '#0EAAA4', textDecoration: 'none' }
const footerBtn = {
  background: 'none', border: 'none',
  color: 'rgba(245,237,216,0.4)', cursor: 'pointer',
  fontSize: 13, fontFamily: '"DM Sans", sans-serif', padding: 0,
}

function Section({ children }) {
  return (
    <h2 style={{
      fontFamily: '"Playfair Display", serif',
      fontSize: 20, fontWeight: 700,
      color: '#fff', marginTop: 44, marginBottom: 12,
    }}>{children}</h2>
  )
}

function Sub({ children }) {
  return (
    <h3 style={{
      fontSize: 15, fontWeight: 700,
      color: '#E8614A', marginTop: 20, marginBottom: 8,
    }}>{children}</h3>
  )
}
